import { render, staticRenderFns } from "./ResourcesEditModal.vue?vue&type=template&id=49ad3255&scoped=true&"
import script from "./ResourcesEditModal.vue?vue&type=script&lang=js&"
export * from "./ResourcesEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesEditModal.vue?vue&type=style&index=0&id=49ad3255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ad3255",
  null
  
)

export default component.exports